import { createStore } from 'redux'
import reducer from './reducer' //reducer组件

const store = createStore(reducer)

export default store
